import type { HelpFile } from '../../types/help'
import { SeverityBadgeTestIds } from '../../../testids/SeverityBadgeTestIds'

export const severityBadgeHelp: HelpFile = {
  docPage: '/docs/schema/violations',
  texts: {
    [SeverityBadgeTestIds.severityBadgeRow]:
      'Per-entity violation summary — counts open violations grouped by severity. Click any badge to drill into the violation list filtered to this entity.',
    [SeverityBadgeTestIds.severityBadgeLink]: 'Navigate to the violation list filtered to the entity carrying this badge.',
    [SeverityBadgeTestIds.severityBadgeCritical]: 'Number of open CRITICAL violations on this entity.',
    [SeverityBadgeTestIds.severityBadgeError]: 'Number of open ERROR violations on this entity.',
    [SeverityBadgeTestIds.severityBadgeWarn]: 'Number of open WARN violations on this entity.',
    [SeverityBadgeTestIds.severityBadgeReferenceBroken]:
      'At least one of the entity references on this violation can no longer be resolved — usually a deleted target. Resolve the violation or restore the target.',
    [SeverityBadgeTestIds.severityBadgeZero]: 'No open violations on this entity.',
  },
}
